export const GET_CITY = 'pop/citys';
export const COMMIT_INFO = 'apply';
export const SAVE_INFO_BUI = 'bui/ue/add';
export const SAVE_INFO = 'ue/add';
export const JUDGELIMIT = 'judgeLimit';



// WEBPACK FOOTER //
// ./src/pages/newHome/consts/urlType.js